/** @jsx jsx */
import { css as emotionCss, jsx } from '@emotion/react';

import * as React from 'react';

import classNames from 'classnames';

import { FormattedMessage } from 'js/lib/coursera.react-intl';
import { FormattedHTMLMessage } from 'js/lib/coursera.react-intl';

import { Typography2 } from '@coursera/cds-core';
import { StyleSheet, breakPoint, css } from '@coursera/coursera-ui';

import { getCopy } from 'bundles/coursera-plus-common/utils/courseraPlusUtils';
import SimpleRichTextContentful from 'bundles/coursera-plus-landing-page/components/SimpleRichTextContentful';
import type { RichTextObject } from 'bundles/coursera-plus-landing-page/components/SimpleRichTextContentful';
import { landingPageTypeChoices } from 'bundles/coursera-plus-landing-page/contentful/constants';
import { useLandingPageExtended } from 'bundles/coursera-plus-landing-page/contentfulData/useLandingPageData';
import { useIsCourseraPlusPromoPage } from 'bundles/coursera-plus-landing-page/utils';

import _t from 'i18n!nls/coursera-plus-landing-page';

const emotionStyles = {
  footerText: emotionCss`
    color: var(--cds-color-neutral-primary-invert);
  `,
};

export const styles = StyleSheet.create({
  footerText: {
    marginBottom: '6px',
  },
  hideText: {
    [`@media (max-width: ${breakPoint.sm - 1}px)`]: {
      display: 'none',
      marginBottom: '0px',
    },
  },
});

const FooterContentfulText = () => {
  const landingPageExtended = useLandingPageExtended();
  const isPromoPage = useIsCourseraPlusPromoPage();
  const { landingPage, isCourseraPlusOwner, isCourseraLiteOwner } = landingPageExtended;
  const { showFooterTextOnMobile, footerText2, heroTextMedium2, landingPageType } = landingPage;
  const className = classNames(css(styles.footerText).className, {
    [css(styles.hideText).className]: !showFooterTextOnMobile,
  });
  const { numberOfProducts, collectionFooterText } = getCopy();

  if (landingPageType === landingPageTypeChoices.COMPUTER_SCIENCE_COLLECTION) {
    return (
      <div className={className}>
        <Typography2 variant="bodyPrimary" component="span" css={emotionStyles.footerText}>
          <FormattedHTMLMessage message={collectionFooterText} numberOfProducts={numberOfProducts} />
        </Typography2>
      </div>
    );
  }

  const text = footerText2 ?? heroTextMedium2;

  const isCPlusOrCLiteOwnerOnPromoPage = (isCourseraPlusOwner || isCourseraLiteOwner) && isPromoPage;
  let footerTextContent: JSX.Element | null | undefined = text && (
    <SimpleRichTextContentful richText={text as RichTextObject} />
  );

  if (isCPlusOrCLiteOwnerOnPromoPage) {
    // On promo pages, we do not set this text on the Contentful side
    // for Coursera Plus (or Lite) owners, so we have to hard code it here.
    footerTextContent = (
      <FormattedMessage
        message={_t('Achieve your career goals with {productTypeName}')}
        productTypeName={isCourseraLiteOwner ? _t('Coursera Lite') : _t('Coursera Plus')}
      />
    );
  }

  return (
    <div className={className}>
      <Typography2 variant="bodyPrimary" component="span" css={emotionStyles.footerText}>
        {footerTextContent}
      </Typography2>
    </div>
  );
};

export default FooterContentfulText;
